import { RefObject } from 'react'
import { XYCoord, DropTargetMonitor } from 'react-dnd'

import { ListItemType } from './types'

export function handleVerticalMovement(
    ref: RefObject<HTMLDivElement | null>,
    index: number,
    moveItem: (dragIndex: number, hoverIndex: number) => void,
    item: ListItemType,
    monitor: DropTargetMonitor,
) {
    if (!ref.current) return

    const dragIndex = item.index
    const hoverIndex = index

    if (dragIndex === hoverIndex) return

    const hoverBoundingRect = ref.current?.getBoundingClientRect()
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
    const clientOffset = monitor.getClientOffset()
    const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return

    moveItem(dragIndex, hoverIndex)

    item.index = hoverIndex
}

export function handleHorizontalMovement(
    ref: RefObject<HTMLDivElement>,
    index: number,
    moveItem: (dragIndex: number, hoverIndex: number) => void,
    item: ListItemType,
    monitor: DropTargetMonitor,
) {
    if (!ref.current) return

    const dragIndex = item.index
    const hoverIndex = index

    if (dragIndex === hoverIndex) return

    const hoverBoundingRect = ref.current?.getBoundingClientRect()
    const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2
    const clientOffset = monitor.getClientOffset()
    const hoverClientX = (clientOffset as XYCoord).x - hoverBoundingRect.left

    if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) return
    if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) return

    moveItem(dragIndex, hoverIndex)

    item.index = hoverIndex
}

export function handleOmnidirectionalMovement(
    ref: RefObject<HTMLDivElement>,
    index: number,
    moveItem: (dragIndex: number, hoverIndex: number) => void,
    item: ListItemType,
    monitor: DropTargetMonitor,
) {
    if (!ref.current) return

    const dragIndex = item.index
    const hoverIndex = index

    if (dragIndex === hoverIndex) return

    const hoverBoundingRect = ref.current?.getBoundingClientRect()
    const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
    const clientOffset = monitor.getClientOffset()
    const hoverClientX = (clientOffset as XYCoord).x - hoverBoundingRect.left
    const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top

    const isOnLeftSide = hoverClientX < hoverMiddleX
    const isOnRightSide = hoverClientX > hoverMiddleX
    const isOnTopSide = hoverClientY < hoverMiddleY
    const isOnBottomSide = hoverClientY > hoverMiddleY

    if (dragIndex < hoverIndex && isOnTopSide && isOnLeftSide) return
    if (dragIndex > hoverIndex && isOnBottomSide && isOnRightSide) return

    moveItem(dragIndex, hoverIndex)

    item.index = hoverIndex
}
